import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import { authService } from '@/services/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/views/Contact.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue')
    },
    {
      path: '/time-entry',
      name: 'time-entry',
      component: () => import('@/views/TimeEntry.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/expense-entry',
      name: 'expense-entry',
      component: () => import('@/views/ExpenseEntry.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/expense-sheet',
      name: 'expense-sheet',
      component: () => import('@/views/ExpenseSheet.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/unbillable-entry',
      name: 'unbillable-entry',
      component: () => import('@/views/UnbillableEntry.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/tax-calculator',
      name: 'tax-calculator',
      component: () => import('@/views/TaxCalculator.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/time-log',
      name: 'time-log',
      component: () => import('@/views/TimeLog.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/invoices',
      name: 'invoices',
      component: () => import('@/views/Invoices.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/invoices/:id',
      name: 'invoice-detail',
      component: () => import('@/views/InvoiceDetail.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/clients',
      name: 'clients',
      component: () => import('@/views/Clients.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/Dashboard.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/business-calculations',
      name: 'business-calculations',
      component: () => import('@/views/BusinessCalculations.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/fsu-projects',
      name: 'fsu-projects',
      component: () => import('@/views/FSUProjects.vue'),
      meta: { requiresAuth: true }
    }
  ]
})

// Route guard for Cloudflare Access authentication
router.beforeEach(async (to, from, next) => {
  // For protected routes, check authentication with the API
  if (to.meta.requiresAuth) {
    const user = await authService.checkAuth()

    if (!user) {
      // Not authenticated - Cloudflare Access will redirect to login
      // Just try to access the API and let Cloudflare handle it
      window.location.href = 'https://api.calmren.com/api/dashboard'
      return
    }
  }

  // Skip login page since Cloudflare Access handles login
  if (to.path === '/login') {
    next('/dashboard')
    return
  }

  next()
})

export default router
